import Axios from 'axios';

class Baseurl {
  constructor(baseurl) {
    this.baseurl = baseurl;
  }
  getUrl() {
    if (this.baseurl) {
      return Promise.resolve(this.baseurl);
    } else {
      return this.initUrl();
    }
  }
  setUrl(baseurl) {
    this.baseurl = baseurl;
    // this.cacheUrl(baseurl);
  }
  fetchUrl() {
    return Axios.get('/service/getServerMap.action').then(res => {
      if (res.status === 200 && res.data.result === 'ok') {
        return res.data.data.data.consoleServerUrl;
      } else {
        throw new Error(`getServerMap Error ${res.statusText} ${res.data.result}`);
      }
    });
  }
  initUrl() {
    // const cachedUrl = sessionStorage.getItem('bossServerUrl');
    // if (cachedUrl) {
    //   return Promise.resolve(cachedUrl);
    // } else {
    return this.fetchUrl().then(url => {
      this.setUrl(url);
      return url;
    });
    // }
  }
  // cacheUrl(baseurl) {
  //   sessionStorage.setItem('bossServerUrl', baseurl);
  // }
}

const BaseurlInstance = new Baseurl();

export default BaseurlInstance;
